<template>
  <div>

    <v-btn @click="login" :loading="loading">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg">
        <g>
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
          <path fill="none" d="M0 0h48v48H0z"></path>
        </g>
      </svg>
      {{ $t('auth.SignInWithGoogleButton') }}</v-btn>

    <login-failed-dialog v-if="showLoginFailedDialog" :show="showLoginFailedDialog" @closeDialog="showLoginFailedDialog = false"/>

  </div>
</template>

<script>
  import _ from 'lodash';
  import {BASE_API_URL} from '@/store'
  import {mapActions} from 'vuex'
  import log from 'loglevel'
  import {mdiGoogle} from '@mdi/js'
  import LoginFailedDialog from '@/components/auth/LoginFailedDialog'

  export default {
    name: "GoogleLogin",
    components: {
      LoginFailedDialog
    },
    data() {
      return {
        dialog: false,
        gsiClientURL: 'https://accounts.google.com/gsi/client',
        icons: {
          mdiGoogle
        },
        loading: false,
        showLoginFailedDialog: false,
      }
    },
    computed: {
      client_id() {
        return this.$store.state.client_id
      }
    },
    mounted() {
      // Call the loadGoogleApi method when the component is mounted
      this.loadGoogleApi()
    },
    methods: {
      ...mapActions([
        'tosScreen',
        'userAuthenticate'
      ]),
      // Handle the Google Sign-In credential response
      async handleCredentialResponse(authResponse) {
        // The ID token
        const id_token = authResponse.credential

        // send the ID token to server for verification
        if (id_token) {
          try {
            // Send the token to server for verification
            let response = await this.axios.post(
              `${BASE_API_URL}/api/v2/users/google-signin/?client_id=${this.client_id}`,
              {
                access_token: id_token,
                locale: this.$i18n.locale
              }
            )
            this.tosScreen({show: false})
            if (response.data) {
              await this.userAuthenticate({access_token: response.data.access_token})
              if (this.$store.getters.isAuthenticated) {
                this.tosScreen({show: false})
                if (this.$store.getters.isOpenIdProvider) {
                  this.$router.push({name: 'openid'})
                } else {
                  this.$router.push({name: 'home'})
                }
              }
            }
          } catch (error) {
            this.handleErrorCredentialResponse(error)
          } finally {
            this.loading = false
          }
        }
      },
      // Handle the error response
      handleErrorCredentialResponse(error) {
        log.error('error: ', error)
        this.tosScreen({show: false})
        this.showLoginFailedDialog = true
        this.loading = false
      },
      // Initialize Google Sign-In once the script has been loaded
      initGoogleSignIn() {
        try {
          window.google.accounts.id.initialize({
            client_id: _.get(this.$store.getters.extensionSettings, 'auth.google_login.web_client_id', ''),
            callback: this.handleCredentialResponse,
            error_callback: this.handleErrorCredentialResponse,
          })
        } catch (err) {
          log.error(err)
        }
      },
      // Load the Google Sign-In script
      async loadGoogleApi() {
        try {
          const el = document.getElementById('auth2_script_id')
          if (!el) {
            let gplatformScript = document.createElement('script')
            gplatformScript.setAttribute('src', this.gsiClientURL)
            gplatformScript.setAttribute('async', true)
            gplatformScript.setAttribute('defer', 'defer')
            gplatformScript.setAttribute('id', 'auth2_script_id')
            gplatformScript.onload = this.initGoogleSignIn
            // Append the script element to the document's <head> section
            document.head.appendChild(gplatformScript)
          }
        } catch (error) {
          log.error('error loading Google API', error)
        }
      },
      login() {
        this.tosScreen({show: true, acceptAction: this.performLogin, rejectAction: this.rejectTOS})
      },
      async performLogin() {
        this.loading = true
        try {
          await this.signIn()
        } catch (error) {
          this.handleErrorCredentialResponse(error)
        } finally {
          this.loading = false
        }
      },
      rejectTOS() {
        this.tosScreen({show: false})
      },
      signIn() {
        // Display google accounts prompt
        window.google.accounts.id.prompt()
      }

    }
  }
</script>

<style scoped>
  .v-btn {
    color: #757575 !important;
    background: #fff !important;
    text-transform: none;
    letter-spacing: 0;
    border: 1px solid #c2c2c2;
  }
  .v-btn svg {
    margin-left: -4px;
    margin-right: 8px;
  }
</style>
